export default __webpack_public_path__ + "images/0xd586e7f844cea2f87f50152665bcbc2c279d8d70.png";